var exports = {
  "kL": "CreatePollModal.module__container___OFFPQl",
  "Y8": "CreatePollModal.module__fieldGroup___OFFPQl",
  "Pf": "CreatePollModal.module__label___OFFPQl",
  "hF": "CreatePollModal.module__input___OFFPQl",
  "iy": "CreatePollModal.module__optionsContainer___OFFPQl",
  "wV": "CreatePollModal.module__optionRow___OFFPQl",
  "VU": "CreatePollModal.module__emojiSelectButton___OFFPQl",
  "qS": "CreatePollModal.module__optionInput___OFFPQl",
  "G5": "CreatePollModal.module__deleteButton___OFFPQl",
  "h_": "CreatePollModal.module__addOptionButton___OFFPQl",
  "No": "CreatePollModal.module__durationGrid___OFFPQl",
  "jZ": "CreatePollModal.module__durationButton___OFFPQl",
  "DU": "CreatePollModal.module__durationButtonActive___OFFPQl",
  "xH": "CreatePollModal.module__switchRow___OFFPQl",
  "d8": "CreatePollModal.module__switchLabel___OFFPQl",
  "vd": "CreatePollModal.module__switchTitle___OFFPQl",
  "rZ": "CreatePollModal.module__switchSub___OFFPQl",
};

module.exports = exports;
